import React from 'react';

export default function(size=32, style={}, config={}) {
  const isFriendly = config.isFriendly || false;

  const outlineColor = isFriendly ? "#4a90e2" : "#e93434";
  const bodyColor = isFriendly ? "#99bce4" : "#fa9f9f";
  const lightColor = isFriendly ? "#4a90e2" : "#fab9b9";

  return (
    <svg width={size} height={size} style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" shapeRendering="crispEdges">
      <path stroke={outlineColor} d="M15 0h3M14 1h1M18 1h1M15 2h1M17 2h1M16 3h1" />
      <path stroke={lightColor} d="M15 1h1" />
      <path stroke={bodyColor} d="M16 1h2M16 2h1" />
    </svg>
  )
}


// WEBPACK FOOTER //
// ./src/battle/svg-getters/CombatantTargetMarker.js